import type {
    ContentPageTypeFields,
    LightEntry,
} from '@beat-venues/common-types';
import { mockMetadata } from '../base.mock';
import { mockContentRichTextBase } from '../content-rich-text.mock';
import { mockContentImageFull } from '../content-image.mock';

export const contentPageMock: LightEntry<ContentPageTypeFields> = {
    sys: {
        id: 'contentPage',
        contentType: {
            sys: {
                id: 'contentPage',
                type: 'Link',
                linkType: 'ContentType',
            },
        },
    },
    metadata: mockMetadata,
    fields: {
        title: 'My content page',
        content: [mockContentRichTextBase],
        image: mockContentImageFull,
    },
};
